import React from 'react';
import './Header.scss';
import { FaSearchPlus, FaSearchMinus, FaSync, FaChevronLeft } from 'react-icons/fa';
import type { Workstation } from '../../types';

export type ConnectionStatus = 'connecting' | 'connected' | 'disconnected';

interface HeaderProps {
  title?: string;
  connectionStatus: ConnectionStatus;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onRefresh: () => void;
  onBack?: () => void;
  selectedWs: number | 'all';
  setSelectedWs: (ws: number | 'all') => void;
  workstations: Workstation[];
}

const Header: React.FC<HeaderProps> = ({
  title = 'KDS',
  connectionStatus,
  onZoomIn,
  onZoomOut,
  onRefresh,
  selectedWs,
  setSelectedWs,
  workstations,
  onBack,
}) => {
  return (
    <div className="kds-header-container">
      <div className="kds-topbar">
        <div className="left">
          {onBack && (
            <button className="back-button" onClick={onBack} aria-label="Volver">
              <FaChevronLeft />
              <span>Volver</span>
            </button>
          )}
        </div>

        <h1 className="kds-header">{title}</h1>

        <div className="right">
          <div className="connection-indicator">
            <span className={`status-badge ${connectionStatus}`}>
              {connectionStatus === 'connected' && 'Conectado'}
              {connectionStatus === 'connecting' && 'Conectando...'}
              {connectionStatus === 'disconnected' && 'Desconectado'}
            </span>
          </div>
          <div className="kds-zoom-controls">
            <button onClick={onZoomOut} title="Zoom Out">
              <FaSearchMinus />
            </button>
            <button onClick={onZoomIn} title="Zoom In">
              <FaSearchPlus />
            </button>
            <button onClick={onRefresh} title="Refresh" className="refresh-btn">
              <FaSync />
            </button>
          </div>
        </div>
      </div>

      <div className="kds-tabs">
        <button
          className={`tab ${selectedWs === 'all' ? 'active' : ''}`}
          onClick={() => setSelectedWs('all')}
        >
          Todas
        </button>
        {workstations.map((ws) => (
          <button
            key={ws.workstation_id}
            className={`tab ${selectedWs === ws.workstation_id ? 'active' : ''}`}
            onClick={() => setSelectedWs(ws.workstation_id)}
          >
            {ws.workstation_name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Header;
